import React, { useMemo } from 'react';

import { GenericModal } from '../../../../../shared/ui/GenericModal';
import { PersonalBroadcastsForm } from '../../../views/Broadcasts/PersonalBroadcastsForm';

export const PersonalBroadcastsModal = ({
    isOpen,
    setIsOpen,
    formik,
    onSave,
    isLoading,
}) => {
    const isSubmittable = useMemo(() => {
        return formik.values.image !== null || formik.values.text.length >= 1;
    }, [formik.values.image, formik.values.text]);

    return (
        <GenericModal
            okButtonProps={{
                disabled: isLoading || !isSubmittable,
                loading: isLoading,
            }}
            onConfirm={() => onSave(formik.values)}
            okText={'Отправить'}
            onCancel={() => setIsOpen(false)}
            title={'Написать сообщение'}
            open={isOpen}
        >
            <PersonalBroadcastsForm formik={formik} />
        </GenericModal>
    );
};
